import styled, { css } from 'styled-components/macro';

export const Grid = styled.div`
  display: grid;
  grid-gap: ${(p) => p.theme.spacing.large};

  @media screen and (min-width: 50rem) {
    grid-template-columns: 1fr 1fr;
    grid-gap: ${(p) => p.theme.spacing.huge};
  }
`;

const sharedStyles = css`
  padding: ${({ theme }) => `0 ${theme.spacing.small}`};
  @media screen and (max-width: 40em) {
    padding: ${({ theme }) =>
      `${theme.spacing.small} 0 ${theme.spacing.medium}`};
  }
`;

export const Container = styled.section<{ short?: boolean }>`
  margin: ${({ short }) => (short ? `0 0.5em 0.5em` : '0.5em')};
  padding: 0 1.5em;
  background: white;

  @media screen and (min-width: 50em) {
    width: ${({ theme }) => `${theme.layout.smallScreen * 100}%`};
    margin: ${({ theme, short }) =>
      short
        ? `0 auto ${theme.spacing.medium}`
        : `${theme.spacing.medium} auto`};
  }

  @media screen and (min-width: 80em) {
    width: ${({ theme }) => `${theme.layout.largeScreen * 100}%`};
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  margin-bottom: ${({ theme }) => theme.spacing.xsmall};

  @media screen and (min-width: 50em) {
    flex-direction: row;
    margin-bottom: 0;
  }
`;

export const SourceBreakdownTitle = styled.header`
  margin-top: ${({ theme }) => theme.spacing.large};
  margin-bottom: ${({ theme }) => theme.spacing.medium};

  & svg {
    margin-bottom: -9px;
  }
`;

export const TitleBar = styled.header<{
  isNotPadded?: boolean;
  isMobile?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  ${sharedStyles};
  color: ${({ theme }): string => theme.NightBlue};
  padding-bottom: ${({ isNotPadded, isMobile }) =>
    isNotPadded && isMobile && '0.2em !important'};
`;

export const Title = styled.h2<{
  isNotPadded?: boolean;
  isMobile?: boolean;
}>`
  flex-basis: auto;
  margin: ${({ theme, isMobile, isNotPadded }) =>
    `${theme.spacing.large} 1em ${isNotPadded && isMobile ? 0 : '0.3em'} 0`};
  font-size: 24px;
  @media screen and (max-width: 40em) {
    margin-top: 0;
    font-size: 20px;
  }
  a {
    box-shadow: none;
    &:hover {
      box-shadow: 0 2px 0 0 ${({ theme }) => theme.AccentGreen};
    }
    svg {
      color: ${({ theme }) => theme.NightBlue};
    }
  }
`;

export const HeaderLink = styled.nav`
  display: none;
  justify-self: flex-end;

  @media screen and (min-width: 50em) {
    display: block;
  }
`;

export const Filters = styled.aside<{
  isNotPadded: boolean | undefined;
  isMobile: boolean | undefined;
}>`
  ${sharedStyles};
  padding-top: ${({ isNotPadded, isMobile }) =>
    isNotPadded && isMobile && '0 !important'};
  padding-bottom: ${({ isNotPadded, isMobile }) =>
    isNotPadded && isMobile && '1.5em !important'};
`;

export const Content = styled.div`
  ${sharedStyles};
  margin: ${({ theme }) => `${theme.spacing.large} 0 0`};
  padding-bottom: ${({ theme }) => theme.spacing.large};
`;

export const FooterBar = styled.nav`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => `${theme.spacing.medium} ${theme.spacing.xlarge}`};
  border-top: ${({ theme }) => `1px solid ${theme.LightGrey}`};

  @media screen and (min-width: 50em) {
    display: none;
  }
`;

export const HeaderLinkWrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;

  & > div {
    position: relative;
    right: -13px;

    @media screen and (min-width: 50rem) {
      top: -13px;
    }
  }
`;
